import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { ProductsBiocatchEnum, StepBiocatchEnum, } from 'src/app/shared/enums/biocatchContext.enum';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { IdentificationService } from 'src/app/shared/services/identification/identification.service';
import { PostValidateService } from 'src/app/shared/services/post-validate/post-validate.service';
import { RISK_LEVELS } from '../../../shared/constants/rate.constants';
import { OpEnum } from '../../../shared/enums/op.enum';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { RequestService } from '../../../shared/services/request/request-onboarding.service';
import { HelpersService } from '../../../shared/services/helpers/helpers-onboarding.service';
import { ProductLoaderService } from './../../../shared/services/product-loader/product-loader.service';
import { AdjustEvent } from 'src/app/shared/services/external/adjust/adjust.service';
import { callbackAdjustContratarTC } from 'src/app/shared/constants/adjust-callback';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
var OfferComponent = /** @class */ (function () {
    function OfferComponent(copyService, headerService, navigationService, captureService, abreCuentasService, parametersService, requestService, biocatchService, bitacoraService, productLoaderService, helperService, postValidate, identificationService, adjustEvent, taggingService) {
        this.copyService = copyService;
        this.headerService = headerService;
        this.navigationService = navigationService;
        this.captureService = captureService;
        this.abreCuentasService = abreCuentasService;
        this.parametersService = parametersService;
        this.requestService = requestService;
        this.biocatchService = biocatchService;
        this.bitacoraService = bitacoraService;
        this.productLoaderService = productLoaderService;
        this.helperService = helperService;
        this.postValidate = postValidate;
        this.identificationService = identificationService;
        this.adjustEvent = adjustEvent;
        this.taggingService = taggingService;
        this.showRate = false;
        this.productsMulti = [];
        this.RISK_LEVELS = RISK_LEVELS;
        this.headerService.show(false, true, true);
    }
    OfferComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.sendTagging('init');
        this.rateTerm = this.abreCuentasService.getAbreCuentasModel().creditParms.maxPeriodValue;
        var product = this.abreCuentasService.getproductSelected().product_code;
        this.caseNum = this.abreCuentasService.getAbreCuentasModel().solicitationId;
        this.mes = this.abreCuentasService.getAbreCuentasModel().creditParms.maxPeriodValue;
        // productsMulti -> get list of multiproduct
        this.productsMulti = this.abreCuentasService.getProductsSelects();
        var isPreloginOnly = (this.biocatchService.isEvidenteCase() && product === ProductsBiocatchEnum.VIV);
        this.biocatchService.changeContext(StepBiocatchEnum.oferta, product, false, isPreloginOnly);
        this.screenCopies = {};
        this.documentInfo = this.abreCuentasService.getDocumentInfo();
        var productSelected = this.abreCuentasService.getproductSelected();
        this.hasLoanProduct = this.loanExists();
        this.product_type = productSelected.product_type;
        var dataProducts = this.productsMulti.filter(function (dataProduct) { return dataProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE; });
        if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE || dataProducts.length > 0) {
            this.amount = '';
            if (this.abreCuentasService.viewOptionMultiProduct) {
                this.productsMulti.forEach(function (products) {
                    _this.aprovedAmount = _this.abreCuentasService.getAmout(products.product_type) ?
                        _this.abreCuentasService.getAmout(products.product_type).toString() : '';
                });
            }
            else {
                this.amount = this.abreCuentasService.getAmountPcoAproved() !== undefined
                    ? this.abreCuentasService.getAmountPcoAproved().toString()
                    : ' ';
            }
            this.mes = this.abreCuentasService.getAbreCuentasModel().creditParms.maxPeriodValue;
            this.segment_id = this.abreCuentasService.getinfoInferredIncomes().segment_id;
            var rates = this.requestService.getRates();
            this.rateLiving = rates[0].value + "% " + rates[0].type + "  (" + rates[1].value + "% " + rates[1].type + ")";
            this.getRates();
        }
        else if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
            this.bitacoraService.saveDataInBitacora('offer_pco_approved');
            var resultpc = this.abreCuentasService.getPcoModel();
            var rates = this.requestService.getRates();
            this.rateLiving = rates[0].value + "% " + rates[0].type + "  (" + rates[1].value + "% " + rates[1].type + ")";
            this.simulator = this.abreCuentasService.getSimulatorModel();
            this.mes = this.simulator.term;
            this.subtype = this.simulator.product_subtype;
            this.subline = this.simulator.product_name;
            this.codesubline = this.simulator.product_subline;
            this.purchase =
                this.subtype === 'LEA' &&
                    (this.codesubline === '01' ||
                        this.codesubline === '07' ||
                        this.codesubline === '03')
                    ? true
                    : false;
            this.purchasePercent = this.simulator.purchase;
            this.getRates();
        }
        if (this.hasLoanProduct) {
            var rates = this.abreCuentasService.getRatesLoan();
            this.rateLiving = "" + rates;
        }
        if (!this.abreCuentasService.viewOptionMultiProduct) {
            var amount = this.abreCuentasService.getAmountPcoAproved() === undefined ||
                this.abreCuentasService.getAmountPcoAproved() === null
                ? 0
                : this.abreCuentasService.getAmountPcoAproved();
            this.amount = amount.toString();
            this.amountPco = this.amount
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
                .split(/\ /)
                .join('')
                .trim();
        }
        /*else{
          console.log('--', this.abreCuentasService.getAbreCuentasModel());
          const amount =
            this.abreCuentasService.getAmountPcoAprovedMulti('') != undefined ||
              this.abreCuentasService.getAmountPcoAproved() === null
              ? 0
              : this.abreCuentasService.getAmountPcoAproved();
          this.amount = amount.toString();
          this.amountPco = this.amount
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
            .split(/\ /)
            .join('')
            .trim();
        }*/
        this.resultPco = 'PCO01';
        this.setCopies(this.resultPco);
    };
    OfferComponent.prototype.getRates = function () {
        this.taxRates = this.requestService.getRates();
        this.showRate = true;
    };
    /**
     * Summary Go to next Step
     */
    OfferComponent.prototype.setCopies = function (resultPco) {
        switch (resultPco) {
            case 'PCO01':
                switch (this.product_type) {
                    case BUSINESS_CONST.PRODUCT_TYPE_TC:
                        this.screenCopies = this.copyService.copies.offer_multi;
                        this.options = this.parametersService.getSetting(OpEnum.ALLIANCES_TC);
                        break;
                    case BUSINESS_CONST.PRODUCT_TYPE_REVOLVING:
                        this.screenCopies = this.copyService.copies.resolvinf_credit;
                        this.options = this.parametersService.getSetting(OpEnum.REVOLVING_CREDIT_CHARACTERISTICS);
                        break;
                    case BUSINESS_CONST.PRODUCT_TYPE_FREE:
                        this.screenCopies = this.copyService.copies.type_free;
                        this.options = this.parametersService.getSetting(OpEnum.FREE_CREDIT_CHARACTERISTICS);
                        break;
                    case BUSINESS_CONST.PRODUCT_TYPE_LIVING:
                        this.screenCopies = this.copyService.copies.offer_type_living;
                        this.textApproved =
                            (this.subtype === 'LEA' && this.codesubline === '03') ||
                                (this.subtype === 'HIP' && this.codesubline === '55')
                                ? this.screenCopies.title_5
                                : this.screenCopies.title_4;
                        if (this.subtype === 'LEA' ||
                            (this.subtype === 'HIP' && this.codesubline === '55')) {
                            this.labelDetail = this.screenCopies.text_zona_gris;
                        }
                        else {
                            this.labelDetail = this.screenCopies.text_zona_gris2;
                        }
                        this.labelValue = this.screenCopies.valor;
                        this.options = this.parametersService.getSetting(OpEnum.LIVING_CHARACTERISTICS);
                        break;
                    case BUSINESS_CONST.MULTI:
                        this.screenCopies = this.copyService.copies.offer_multi;
                        break;
                    default:
                        break;
                }
                break;
            case 'PCO02':
                switch (this.product_type) {
                    case BUSINESS_CONST.PRODUCT_TYPE_REVOLVING:
                        this.screenCopies = this.copyService.copies.offer_resolvinf_credit;
                        this.options = this.parametersService.getSetting(OpEnum.REVOLVING_CREDIT_CHARACTERISTICS_MULTI);
                        break;
                    case BUSINESS_CONST.PRODUCT_TYPE_FREE:
                        this.screenCopies = this.copyService.copies.offer_type_free;
                        this.options = this.parametersService.getSetting(OpEnum.FREE_CREDIT_CHARACTERISTICS);
                        break;
                    default:
                        break;
                }
                break;
            default:
                break;
        }
    };
    OfferComponent.prototype.loanExists = function () {
        var exists = false;
        this.productsMulti.forEach(function (dataProduct) {
            if (dataProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN) {
                exists = true;
            }
        });
        return exists;
    };
    OfferComponent.prototype.goToSupportDocuments = function () {
        this.navigationService.navigateTo('support-documents');
    };
    OfferComponent.prototype.previous = function () {
        this.sendTagging('prev', 'center', '1');
        this.bitacoraService.saveDataInBitacora('mejor_otro_dia_pco');
        this.navigationService.navigateToGeneralInformation('512');
    };
    OfferComponent.prototype.editOfert = function (product) {
        this.abreCuentasService.setEditProduct(product);
        this.navigationService.nextStep('202');
    };
    OfferComponent.prototype.checkBioCatch = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.sendTagging('next', 'center', '2');
                        if (this.product_type !== BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
                            this.next();
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.biocatchService.update()];
                    case 1:
                        _a.sent();
                        this.biocatchService.checkScore(false).then(function (response) {
                            if (response.data.response) {
                                _this.next();
                                return;
                            }
                            _this.navigationService.navigateToGeneralInformation('122');
                            _this.navigationService.pageLoadTag('Error carga vinculacion', ['', 'pv132', 'pv93']);
                        }, function () {
                            _this.navigationService.navigateToGeneralInformation('500');
                        }).catch(function () { return _this.navigationService.navigateToGeneralInformation('500'); });
                        return [2 /*return*/];
                }
            });
        });
    };
    OfferComponent.prototype.next = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING)) return [3 /*break*/, 12];
                        this.productLoaderService.show(this.copyService.copies.show_offer_pco);
                        if (!(this.abreCuentasService.getProspectResponse().list_query_status
                            .status_code === '2' ||
                            (typeof this.abreCuentasService.getSecondHeadline() !== 'undefined' &&
                                this.abreCuentasService.getSecondHeadline().has_second_headline &&
                                this.abreCuentasService.getProspectResponseSecondHeadLine()
                                    .list_query_status.status_code === '2'))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.abreCuentasService.sleep(2000)];
                    case 1:
                        _a.sent();
                        this.productLoaderService.hide();
                        this.navigationService.navigateToGeneralInformation('130');
                        return [2 /*return*/];
                    case 2: 
                    // Relacionados
                    return [4 /*yield*/, this.checkRelated()];
                    case 3:
                        // Relacionados
                        _a.sent();
                        if (!this.continueRelated) {
                            this.productLoaderService.hide();
                            return [2 /*return*/];
                        }
                        this.productLoaderService.show(this.copyService.copies.show_offer_pco, this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['ALTA']);
                        this.bitacoraService.saveDataInBitacora('Ini_loading_Product');
                        _a.label = 4;
                    case 4:
                        _a.trys.push([4, 10, , 11]);
                        return [4 /*yield*/, this.postValidate.createClient()];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, this.postValidate.createProducts()];
                    case 6:
                        _a.sent();
                        return [4 /*yield*/, this.postValidate.performSolicitation()];
                    case 7:
                        _a.sent();
                        return [4 /*yield*/, this.abreCuentasService.sleep(this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['ALTA'])];
                    case 8:
                        _a.sent();
                        return [4 /*yield*/, this.captureService
                                .getChannelComunicator(true)
                                .then(function (res2) {
                                if (res2 === '208') {
                                    _this.bitacoraService.saveDataInBitacora('Possible_fraud_Yes');
                                }
                                else if (res2 === '20-04') {
                                    res2 = '208';
                                    _this.bitacoraService.saveDataInBitacora('Possible_fraud_incident');
                                }
                                res2 === '107' ||
                                    res2 === '121' ||
                                    res2 === '130' ||
                                    res2 === '129' ||
                                    res2 === '124' ||
                                    res2 === '127'
                                    ? _this.navigationService.navigateToGeneralInformation(res2)
                                    : _this.navigationService.nextStep(res2);
                                if (_this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC && res2 === '121') {
                                    var event_1 = {
                                        eventToken: 'huswfn',
                                        callbackParams: callbackAdjustContratarTC,
                                    };
                                    _this.adjustEvent.adjustTrackEvent(event_1);
                                }
                                _this.bitacoraService.saveDataInBitacora('Out_loading_Product');
                                _this.productLoaderService.hide();
                            })
                                .catch(function () {
                                return _this.navigationService.navigateToGeneralInformation('107');
                            })];
                    case 9:
                        _a.sent();
                        return [3 /*break*/, 11];
                    case 10:
                        error_1 = _a.sent();
                        console.log(error_1);
                        this.navigationService.navigateToGeneralInformation('107');
                        return [3 /*break*/, 11];
                    case 11:
                        this.bitacoraService.saveDataInBitacora('product_accepted_approved');
                        return [2 /*return*/];
                    case 12:
                        this.navigationService.nextStep('200');
                        return [2 /*return*/];
                }
            });
        });
    };
    OfferComponent.prototype.listBenefits = function (row) {
        return this.parametersService.getSetting(row.options);
    };
    OfferComponent.prototype.getAmountProducts = function (type) {
        return this.abreCuentasService.getAmout(type).toString().
            replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
            .split(/\ /)
            .join('')
            .trim();
    };
    OfferComponent.prototype.checkRelated = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var document, resInfo, bitacoraEvent, pcoStatus;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.continueRelated = true;
                        document = this.abreCuentasService.getDocumentInfo().document_number;
                        return [4 /*yield*/, this.identificationService.validateIfIsRelated(document)];
                    case 1:
                        resInfo = _a.sent();
                        console.log('resInfo');
                        console.log(resInfo);
                        if (!resInfo.related) {
                            return [2 /*return*/];
                        }
                        bitacoraEvent = "employee_members";
                        this.bitacoraService.saveDataInBitacora(bitacoraEvent);
                        pcoStatus = this.abreCuentasService.getPcoModel().solicitation_status.status_code;
                        console.log('pcoStatus');
                        console.log(pcoStatus);
                        // PCO Aprobado continúa a "Tu solicitud fue recibida y la estamos validando"
                        if (pcoStatus !== 'PCO01') {
                            return [2 /*return*/];
                        }
                        this.navigationService.nextStep('203');
                        this.continueRelated = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    OfferComponent.prototype.sendTagging = function (value, position, event) {
        var page = '6';
        var extras = {
            object: 'transactionProductCategory',
            value: 'Aprobado',
            pageValue: 'Offer',
        };
        this.taggingService.sendTaggValues(value, page, position, event, extras);
    };
    return OfferComponent;
}());
export { OfferComponent };
